export default {
  title: 'Politique de confidentialité',
};
